<template>
	<ja-modal
		ref="modal"
		class="sessionLostModal"
		:show="show"
		@close-modal="closeModal"
	>
		<content>
			<div class="heading-2 title">{{ $t('sessionLostModalName') }}</div>
			<div class="body-text-1">
				{{ $t('sessionLostText') }}
			</div>
			<div class="button-wrapper">
				<ja-button
					class="confirm-button large"
					name="confirm"
					:disabled="logoutAttempt"
					@click.native="logout"
				>
					<span>{{ $t('okay') }}</span>
				</ja-button>
			</div>
		</content>
	</ja-modal>
</template>

<script>
import '../icons/arrow-right';
import '../icons/modal-close';
import Button from '../ui/Button';
import Modal from './Modal';
import ModalEvents from '@/mixins/ModalEvents';

export default {
	components: {
		jaButton: Button,
		jaModal: Modal
	},
	mixins: [ModalEvents],
	data() {
		return {
			logoutAttempt: false
		};
	},
	computed: {
		show() {
			return this.$store.getters.sessionLost;
		}
	},
	mounted() {
		this.logoutAttempt = false;
	},
	methods: {
		closeModal() {
			this.$store.commit('closeLogoutModal');
		},
		logout() {
			this.logoutAttempt = true;
			this.closeModal();
			this.$store.commit('setLoading', true);
			this.$store.dispatch('logoutSingleSession');
		}
	}
};
</script>
<style lang="scss" scoped>
.logoutModal {
	z-index: 1001;
}
.heading-2 {
	margin-bottom: 24px;
}
content {
	padding: 48px;
}

.cancel-button,
.confirm-button {
	margin-top: 48px;
}

.cancel-button {
	margin-right: 16px;
}
</style>
